module.exports = __webpack_public_path__ + "img/error-icon.ec125f0b.svg";